import React, { useState } from "react";

import { IMasterServices, IService } from "app/api/types";
import Field from "app/components/Elements/Field";

import "./styles.scss";

interface IProps {
  service: IMasterServices;
  onChange: (e: any) => void;
  onDelete: (serviceId: number) => void;
  masterServices: IMasterServices[];
  serviceList?: IService[];
  isError: boolean;
}

const MasterService: React.FC<IProps> = (props) => {
  const [isError, setError] = useState(
    props.service.time === 0 || props.service.time % 30 !== 0
  );
  const isExists = (id: number) => {
    return props.masterServices.filter((s) => s.serviceId === id).length > 0;
  };

  const handleChange = (e: any) => {
    const targetValue = e.target.value;

    if (e.target.name.split("--")[1] === "time") {
      +targetValue === 0 || +targetValue % 30 !== 0
        ? setError(true)
        : setError(false);
    }

    props.onChange(e);
  };

  return (
    <div key={props.service.serviceId} className="master-services__content">
      <select
        name={`${props.service.serviceId}--serviceId`}
        onChange={handleChange}
        value={props.service.serviceId}
      >
        {props.serviceList?.map(
          (service) =>
            (!isExists(Number(service.id)!) ||
              Number(service.id) === props.service.serviceId) && (
              <option value={Number(service.id)} key={service.id}>
                {service.title}
              </option>
            )
        )}
      </select>
      <Field
        type="number"
        className="mg0"
        isError={isError}
        labelText="время (кратное 30)"
        onChange={handleChange}
        name={`${props.service.serviceId}--time`}
        defaultValue={props.service.time}
        placeholder="время"
      />
      <Field
        type="number"
        className="mg0"
        labelText="цена"
        onChange={handleChange}
        name={`${props.service.serviceId}--price`}
        defaultValue={props.service.price}
        placeholder="цена"
      />
      <p
        className="master-services__del"
        onClick={() => props.onDelete(props.service.serviceId)}
      >
        удалить
      </p>
    </div>
  );
};

export default MasterService;
